import type React from 'react';
import { Badge as TailGridsBadge } from '../tailgrids/core/badge.js';
import { cn } from '../../utils/cn.js';

export type ChipTone = 'neutral' | 'blue' | 'green' | 'purple' | 'teal' | 'warn' | 'danger';

const COLOR: Record<ChipTone, 'gray' | 'primary' | 'success' | 'purple' | 'cyan' | 'warning' | 'error'> = {
  neutral: 'gray',
  blue: 'primary',
  green: 'success',
  purple: 'purple',
  teal: 'cyan',
  warn: 'warning',
  danger: 'error',
};

interface ChipProps {
  tone?: ChipTone;
  /** Optional leading icon (a 12–14px lucide icon). */
  icon?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

/** A small metadata tag (model name, kind, version) — the compact badge. For a status use `Badge`/`StatusBadge`. */
export function Chip({ tone = 'neutral', icon, children, className }: ChipProps) {
  return (
    <TailGridsBadge
      color={COLOR[tone]}
      size="sm"
      className={cn('w-fit max-w-full shrink-0 font-mono text-[11px] whitespace-nowrap', className)}
      prefixIcon={
        icon ? (
          <span className="inline-flex shrink-0 [&>svg]:size-3" aria-hidden="true">
            {icon}
          </span>
        ) : undefined
      }
    >
      {children}
    </TailGridsBadge>
  );
}
